(function () {
  const ADDON_VARIANT_ID = 47685538513155; // $5 add-on variant
  const FIELD_LABEL = "Add Name (Back of Shirt) (Optional)";
  const SECTION_ID = "cart-drawer";

  let syncing = false;
  let lastRun = 0;

  function hasNameProperty(item) {
    const props = item.properties || {};

    if (props[FIELD_LABEL] && String(props[FIELD_LABEL]).trim()) return true;

    for (const k in props) {
      if (k && k.toLowerCase().includes("add name") && String(props[k]).trim()) {
        return true;
      }
    }
    return false;
  }

  async function getCart() {
    const res = await fetch("/cart.js", { headers: { Accept: "application/json" } });
    return res.json();
  }

  function renderCartDrawerFromState(state) {
    try {
      const drawer = document.querySelector("m-cart-drawer");
      if (drawer && state && state.sections) {
        drawer.renderContents(state);
      }
      // also notify other theme parts (header cart count, etc.)
      if (window.MinimogEvents && window.MinimogTheme?.pubSubEvents?.cartUpdate) {
        window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, state);
      }
    } catch (e) {
      console.error("[Name Add-on] render error:", e);
    }
  }

  async function cartAddWithDrawerSection(variantId, qty, properties = {}) {
    const fd = new FormData();
    fd.append("id", String(variantId));
    fd.append("quantity", String(qty));

    Object.entries(properties).forEach(([k, v]) => {
      fd.append(`properties[${k}]`, String(v));
    });

    // 🔑 This is the Minimog drawer refresh key
    fd.append("sections", SECTION_ID);
    fd.append("sections_url", window.location.pathname);

    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { Accept: "application/json" },
      body: fd
    });

    const text = await res.text();
    if (!res.ok) {
      console.error("[Name Add-on] add failed:", text);
      return null;
    }

    const state = JSON.parse(text);
    renderCartDrawerFromState(state);
    return state;
  }

  async function cartChangeWithDrawerSection(line, qty) {
    const fd = new FormData();
    fd.append("line", String(line));
    fd.append("quantity", String(qty));
    fd.append("sections", SECTION_ID);
    fd.append("sections_url", window.location.pathname);

    const res = await fetch("/cart/change.js", {
      method: "POST",
      headers: { Accept: "application/json" },
      body: fd
    });

    const text = await res.text();
    if (!res.ok) {
      console.error("[Name Add-on] change failed:", text);
      return null;
    }

    const state = JSON.parse(text);
    renderCartDrawerFromState(state);
    return state;
  }

  async function syncAddon() {
    const now = Date.now();
    if (now - lastRun < 600) return;
    lastRun = now;

    if (syncing) return;
    syncing = true;

    try {
      const cart = await getCart();

      let neededQty = 0;
      let addonLine = null;
      let addonQty = 0;

      cart.items.forEach((item, idx) => {
        const lineNumber = idx + 1;

        if (item.variant_id === ADDON_VARIANT_ID) {
          addonLine = lineNumber;
          addonQty = item.quantity;
          return;
        }

        if (hasNameProperty(item)) {
          neededQty += item.quantity;
        }
      });

      console.log("[Name Add-on] sync check", { neededQty, addonQty, addonLine });

      // remove add-on if no named items
      if (neededQty === 0 && addonLine) {
        await cartChangeWithDrawerSection(addonLine, 0);
        return;
      }

      // ensure add-on qty matches needed qty
      if (neededQty > 0) {
        if (!addonLine) {
          await cartAddWithDrawerSection(ADDON_VARIANT_ID, neededQty, {
            Personalization: "Name on back"
          });
          return;
        }

        if (addonQty < neededQty) {
          await cartAddWithDrawerSection(ADDON_VARIANT_ID, neededQty - addonQty, {
            Personalization: "Name on back"
          });
          return;
        }

        if (addonQty > neededQty) {
          await cartChangeWithDrawerSection(addonLine, neededQty);
          return;
        }
      }
    } catch (e) {
      console.error("[Name Add-on] sync error:", e);
    } finally {
      syncing = false;
    }
  }

  // Triggers (Minimog-safe)
  function scheduleSyncBurst() {
    setTimeout(syncAddon, 250);
    setTimeout(syncAddon, 900);
    setTimeout(syncAddon, 1700);
  }

  // After Add to Cart clicks
  document.addEventListener(
    "click",
    function (e) {
      if (e.target.closest('button[type="submit"], button[name="add"], [data-add-to-cart]')) {
        scheduleSyncBurst();
      }
    },
    true
  );

  // After any XHR /cart/add completes (Minimog uses XHR internally)
  (function hookXHR() {
    const open = XMLHttpRequest.prototype.open;
    const send = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      this._na_method = method;
      this._na_url = url;
      return open.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function () {
      try {
        const isCartAdd =
          (this._na_method || "").toUpperCase() === "POST" &&
          (this._na_url || "").includes("/cart/add");

        if (isCartAdd) {
          this.addEventListener("loadend", function () {
            scheduleSyncBurst();
          });
        }
      } catch (e) {}
      return send.apply(this, arguments);
    };
  })();

  // Manual tester
  window.NameAddonSync = syncAddon;

  console.log("✅ Name add-on loaded (drawer-section refresh)");
})();
